import { render, staticRenderFns } from "./DatatableSolicitacoes.vue?vue&type=template&id=4478ed7c"
import script from "./DatatableSolicitacoes.vue?vue&type=script&lang=js"
export * from "./DatatableSolicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports